import { render, staticRenderFns } from "./orderrefund.vue?vue&type=template&id=22b86071&scoped=true"
import script from "./orderrefund.vue?vue&type=script&lang=js"
export * from "./orderrefund.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b86071",
  null
  
)

export default component.exports